<div class="container mx-auto p-3">
    <p class="py-3">Copyright &copy; {{currentYear}} AVANACUSO.com</p>
</div>